"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTONS = void 0;
const BUTTONS = exports.BUTTONS = 'buttons';
